import { useQuery } from "convex/react";
import { api } from "../../api";
import { toConvexId } from "@/types/convex";

export const useDeviceRules = (deviceId: string) => {
  // First get device details to access the deviceConfig ID
  const deviceDetails = useQuery(api.devices.get.details, { device: toConvexId.device(deviceId) });
  
  // Then get device rules using the deviceConfig ID
  return useQuery(api.devices.rules.get, 
    deviceDetails?.device?.deviceConfig ? {
      deviceConfig: deviceDetails.device.deviceConfig
    } : "skip"
  );
};